import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { ROUTES } from 'constants/urls'

export const headerMDHeight = 60
export const headerSMHeight = 60
export const PERMISSION = {
  ADMIN: 'ADMIN',
  VENDE: 'VENDE',
  ASVEN: 'ASVEN',
  GENAC: 'GENAC',
  ASVEN_ESP: 'ASVEN_ESP'
} as const
export type ActionPerm = typeof ACTIONS_SCREENS[keyof typeof ACTIONS_SCREENS]
export type ScreenPerm = typeof SCREENS[keyof typeof SCREENS]
export interface OptionProps {
  label: string
  route: string
  screen: ScreenPerm
}
interface navItemInterface {
  label: string
  route: string
  item: Array<OptionProps>
  screen: ScreenPerm | ScreenPerm[]
  action?: ActionPerm
}
interface navItemsInterface {
  [index: string]: navItemInterface
}

export const SM_BREAKPOINT_MODIFIER = 70

const LABEL_PAGE = {
  HOME_PAGE: 'Página Inicial',
  MANAGE_ORDER: 'Gerenciamento',
  ORDERS_MADE: 'Pedidos efetivados',
  ORDER_DRAFTS: 'Rascunhos de pedidos',
  CREATE_ORDER: 'Pedido',
  SINGLE_ORDER: 'Nacional',
  EXPORT_ORDER: 'Internacional',
  FRANCHISES_ORDER: 'Franquias massivo',
  ND: 'Negociação Diferenciada',
  STOCK_REPORT: 'Relatório de Estoque',
  EXTRA_VOLUME: 'Volume extra',
  APROVACOES: 'Aprovações',
  BACKOFFICE: 'Backoffice',
  APPROVAL_RANGES: 'Alçadas de aprovação',
  LEAD_TIMES: 'Lead Times',
  KEY_ACCOUNTS: 'Key Accounts'
}

export const navItems: navItemsInterface = {
  initialPage: {
    label: LABEL_PAGE.HOME_PAGE,
    route: ROUTES.app.base,
    screen: SCREENS.HOME,
    item: []
  },
  createOrder: {
    label: LABEL_PAGE.CREATE_ORDER,
    route: '',
    screen: [SCREENS.ORDER, SCREENS.INTERNATIONAL_EDI],
    item: [
      {
        label: LABEL_PAGE.SINGLE_ORDER,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.new.base}`,
        screen: SCREENS.ORDER
      },
      {
        label: LABEL_PAGE.EXPORT_ORDER,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.batchOrders.base}${ROUTES.orders.children.batchOrders.children.international.base}`,
        screen: SCREENS.INTERNATIONAL_EDI
      },
      {
        label: LABEL_PAGE.FRANCHISES_ORDER,
        route: `${ROUTES.orders.base}${ROUTES.orders.children.batchOrders.base}${ROUTES.orders.children.batchOrders.children.franchises.base}`,
        screen: SCREENS.FRANCHISES_BATCH
      }
    ]
  },
  manageOrder: {
    label: LABEL_PAGE.MANAGE_ORDER,
    route: ROUTES.manage.base,
    screen: SCREENS.MANAGE,
    item: []
  },
  aprovacoes: {
    label: LABEL_PAGE.APROVACOES,
    route: '',
    screen: [SCREENS.ND_MANAGE, SCREENS.EXTRA_VOLUME],
    item: [
      {
        label: LABEL_PAGE.ND,
        route: ROUTES.nd.base,
        screen: SCREENS.ND_MANAGE
      },
      {
        label: LABEL_PAGE.EXTRA_VOLUME,
        route: ROUTES.extra_volume.base,
        screen: SCREENS.EXTRA_VOLUME
      }
    ]
  },
  backoffice: {
    label: LABEL_PAGE.BACKOFFICE,
    route: '',
    screen: [SCREENS.BACKOFFICE_RANGE, SCREENS.TECHNICAL_CONSULTATION],
    item: [
      {
        label: LABEL_PAGE.APPROVAL_RANGES,
        route: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.ranges.base}`,
        screen: SCREENS.BACKOFFICE_RANGE
      },
      {
        label: LABEL_PAGE.LEAD_TIMES,
        route: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.lead_times.base}`,
        screen: SCREENS.TECHNICAL_CONSULTATION
      },
      {
        label: LABEL_PAGE.KEY_ACCOUNTS,
        route: `${ROUTES.backoffice.base}${ROUTES.backoffice.children.key_accounts.base}`,
        screen: SCREENS.TECHNICAL_CONSULTATION
      }
    ]
  },
  stockReport: {
    label: LABEL_PAGE.STOCK_REPORT,
    route: ROUTES.stock_report.base,
    screen: SCREENS.HOME,
    item: []
  }
}

export const PHONE_NUMBER = '(11) 3847-7477'
export const SUPPORT_LINK =
  'https://prodalpargatas.service-now.com/sp?id=sc_cat_item&sys_id=1e3631141bf634104b91da8fe54bcbd6&sysparm_category=f876b1141bf634104b91da8fe54bcbe4'

export const voidFunction = () => {
  return
}
